import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import withStyles from 'material-ui/styles/withStyles';

const styles = theme => ({
	button: {
		padding: 0,
		width: '24px',
		minWidth: '24px',
		minHeight: '24px',
		margin: theme.spacing.unit
	},
	'@media (max-width: 768px)': {
		desktopOnly: {
			display: 'none'
		}
	}
});

const DashboardButton = props => {
	const {
		classes, children, desktopOnly, handler, ...rest
	} = props;
	const className = `${classes.button} ${desktopOnly ? classes.desktopOnly : ''}`;

	return (
		<Button
			color="contrast"
			className={className}
			onClick={handler}
			{...rest}
		>
			{children}
		</Button>
	);
};

DashboardButton.propTypes = {
	classes: PropTypes.object.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.node,
		PropTypes.string
	]),
	handler: PropTypes.func.isRequired,
	desktopOnly: PropTypes.bool
};

export default withStyles(styles)(DashboardButton);



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer-dashboard/dashboard-button/index.jsx